import { defineComponent as _defineComponent } from 'vue'
import { useMainElement } from '@/pinia/modules/mainElement';
import { useRouter } from '@/router';
import { useForm } from '@/util/useForm';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import JumpType from '@/view/operation/components/JumpType.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AdvDetail',
  props: {
    id: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
  id?: number;
  value?: any;
};

const formItemCol = {
  labelCol: { span: 4 },
  wrapperCol: { span: 14 },
};

const form = useForm();

return { __sfc: true,formItemCol, props, form, JumpType }
}

})